// extracted by mini-css-extract-plugin
export default {"addNewMember":"assignApprentice_addNewMember__N4aMK","modalBody":"assignApprentice_modalBody__GK+9N"};